import { API_URL } from '../configs';
import api from './api';

const generateShortlink = async ({
  webAppUrl,
  deeplink,
  appStoreUrl,
  googlePlayUrl,
  ttl,
}) => {
  const response = await api({
    method: 'POST',
    url: `${API_URL}/api/v1/shortlink`,
    data: {
      webAppUrl,
      deeplink,
      appStoreUrl,
      googlePlayUrl,
      ttl,
    },
  });
  return response;
};

export { generateShortlink };
